import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useCard, useProfile, useTranslation } from '@front/model'
import { NotReady } from '@components'
import { MyCardForm } from './MyCardForm'

export function MyCardSettings(): ReactElement {
  const { t } = useTranslation()
  const { company, user, hasPermission } = useProfile()
  const { data: card, isLoading: isLoadingCard, error: cardError } = useCard(company?.companyId)

  if (!company || !user || isLoadingCard || cardError) {
    return <NotReady error={cardError} isLoading={isLoadingCard} />
  }
  if (!hasPermission('companyCard:save')) {
    return <NotReady error={t('You do not have permission to manage MyCard')} />
  }

  return (
    <MyCardForm
      company={company}
      existingCard={card && card.entityType === 'company' ? card : undefined}
      repAvatarUrl={user.avatarUrl ?? ''}
    />
  )
}

export const Route = createFileRoute('/settings/myCard/')({
  component: MyCardSettings,
})
